<template>
  <v-tooltip
    v-if="infoData && infoData.visible"
    right
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="ml-2 my-auto"
        color="var(--color-text)"
        v-bind="attrs"
        v-on="on"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <span>{{ infoData.description }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "InfoIcon",
  props: {
    infoData: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
};
</script>
